import * as constant from './constant'
export function setPortfolioFilters(type, riskLevel, trend, status, clickedAside, selected, country, caseType,state) {
    let filterList = {
        counterpartyType: [selected],
        riskLevel: riskLevel ? [riskLevel] : [],
        reportType: [],
        caseStatus: status ? [status] : [],
        riskTrend: trend ? [trend] : [],
        toDate: null,
        fromDate: null,
        search: "",
        region: [],
        businessSegment: [],
        classOfCompany: [],
        selectedCountry: [],
        caseType: caseType ? [caseType] : [],
        selectedState:[]
    }
    if (clickedAside === constant.GEOGRAPHY) {
        filterList.region = !type || type === constant.ALL ? [] : [type]
        filterList.selectedCountry = !country || type === constant.ALL ? [] : [country]
        filterList.selectedState = !state || type === constant.ALL ? [] : [state]
        filterList.businessSegment = []
        filterList.classOfCompany = []
    } else if (clickedAside === constant.BUSINESSSEGMENT) {
        filterList.region = []
        filterList.businessSegment = !type || type === constant.ALL ? [] : [type]
        filterList.classOfCompany = []
        filterList.selectedCountry =[]
    } else if (clickedAside === constant.LEGALCONSTITUTION) {
        filterList.region = []
        filterList.selectedCountry =[]
        filterList.businessSegment = []
        filterList.classOfCompany = !type || type === constant.ALL ? [] : [type]
    } else if (clickedAside === constant.NICSEGMENT) {
        filterList.region = []
        filterList.nicSegment = !type || type === constant.ALL ? [] : [type]
        filterList.classOfCompany = []
        filterList.selectedCountry =[]
    }
    return filterList
}

export const createUrlParameter = (counterpartyType) => {
    let url = new URLSearchParams();
    counterpartyType && url.set('counterpartyType', counterpartyType.toString());
    return decodeURIComponent(url);
}

export const getUrlParameter = (url) => {
    const params = new URLSearchParams(url);
    return params.get('counterpartyType') ? (params.get('counterpartyType')) : null
}